export interface SettledPromiseFulfilledResult<T> {
    status: 'fulfilled';
    value: T;
}

export interface SettledPromiseRejectedResult {
    status: 'rejected';
    reason: unknown;
}

export type SettledPromiseResult<T> = SettledPromiseFulfilledResult<T> | SettledPromiseRejectedResult;

export function settlePromises<T>(promises: Array<Promise<T>>): Promise<Array<SettledPromiseResult<T>>> {
    // Mirror Promise.allSettled for the current TypeScript target without changing compiler libs.
    return Promise.all(
        promises.map((promise) =>
            Promise.resolve(promise).then(
                (value) => ({
                    status: 'fulfilled' as const,
                    value,
                }),
                (reason) => ({
                    status: 'rejected' as const,
                    reason,
                })
            )
        )
    );
}
